var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 57,
    viewBox: "0 0 302 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.93 27.5469C274.786 27.542 274.643 27.5372 262.496 28.196C250.349 28.8548 226.202 30.1773 203.376 30.5957C180.549 31.0141 159.773 30.4882 140.342 30.4738C120.91 30.4594 103.453 30.9723 84.997 30.5783C66.5414 30.1842 47.6169 28.8677 27.5963 27.596",
    stroke: "white",
    strokeWidth: 52,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.c32c4bd8db9ab07c43ec9c7378f0e5c5.svg";
export { ForwardRef as ReactComponent };